<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="min(860px, calc(100vw - 24px))">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.materialAttributeId" class="title-actions">
        <el-button v-if="isAuth('base:materialAttribute:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:materialAttribute:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="16">
        <el-col :span="12" class="attribute-form-col">
          <el-form-item label="主物料" prop="materialId">
            <el-select v-model="form.materialId" :disabled="readonly" style="width:100%" filterable>
              <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="attribute-form-col">
          <el-form-item label="属性名称" prop="attributeName">
            <el-input v-model="form.attributeName" :disabled="readonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12" class="attribute-form-col">
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="form.sort" :disabled="readonly" :min="0" :step="1" style="width:100%" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="属性值">
        <el-table :data="form.valueList" border size="mini" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="属性值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.attributeValue" :disabled="readonly" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="默认" width="90" align="center">
            <template slot-scope="scope">
              <el-radio v-model="defaultRowIndex" :label="scope.$index" :disabled="readonly" @change="setDefault(scope.$index)">默认</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="排序" width="110">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.sort" :disabled="readonly" :min="0" :step="1" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button v-if="!readonly" type="text" size="small" @click="removeValue(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!readonly" style="margin-top: 8px;">
          <el-button type="primary" size="mini" @click="addValue">新增属性值</el-button>
        </div>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="3" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      visible: false, readonly: false, form: { valueList: [] }, materials: [], permCodes: [],
      defaultRowIndex: -1,
      headStyle: { background: '#f5f7fa', color: '#606266' },
      rules: {
        materialId: [{ required: true, message: '主物料不能为空', trigger: 'change' }],
        attributeName: [{ required: true, message: '属性名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看物料属性'
      return this.form.materialAttributeId ? '修改物料属性' : '新增物料属性'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(row, readonly, materialId) {
      this.loadMaterials()
      this.readonly = !!readonly
      this.visible = true
      this.defaultRowIndex = -1
      const blank = () => ({
        materialId: materialId || '', attributeName: '', sort: 0, remark: '',
        valueList: [{ attributeValue: '', sort: 0, isdefault: '0' }]
      })
      const apply = data => {
        this.form = Object.assign(blank(), data || {})
        this.form.valueList = (this.form.valueList && this.form.valueList.length)
          ? this.form.valueList.map(item => ({
            materialAttributeValueId: item.materialAttributeValueId,
            attributeValue: item.attributeValue,
            sort: item.sort || 0,
            isdefault: String(item.isdefault == null ? '0' : item.isdefault)
          }))
          : [{ attributeValue: '', sort: 0, isdefault: '0' }]
        this.defaultRowIndex = this.form.valueList.findIndex(item => item.isdefault === '1')
        if (this.defaultRowIndex < 0 && this.form.materialAttributeValueId) {
          this.defaultRowIndex = this.form.valueList.findIndex(item => item.materialAttributeValueId === this.form.materialAttributeValueId)
        }
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }
      if (!row || !row.materialAttributeId) {
        apply(blank())
        return
      }
      request.get('/base/materialAttribute/info/' + row.materialAttributeId).then(res => apply(res.data || row)).catch(() => apply(row))
    },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    addValue() {
      this.form.valueList.push({ attributeValue: '', sort: this.form.valueList.length, isdefault: '0' })
    },
    removeValue(index) {
      this.form.valueList.splice(index, 1)
      if (this.defaultRowIndex === index) this.defaultRowIndex = -1
      if (this.defaultRowIndex > index) this.defaultRowIndex--
    },
    setDefault(index) {
      this.form.valueList.forEach((item, idx) => { item.isdefault = idx === index ? '1' : '0' })
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        // Use the radio selection as the source of truth. Its change event is not
        // guaranteed to run when the selection is made with the keyboard.
        const valueList = (this.form.valueList || [])
          .map((item, index) => ({ ...item, isdefault: index === this.defaultRowIndex ? '1' : '0' }))
          .filter(item => (item.attributeValue || '').trim())
        if (!valueList.length) {
          this.$message.warning('请至少维护一条属性值')
          return
        }
        const body = {
          materialAttributeId: this.form.materialAttributeId || undefined,
          materialId: this.form.materialId,
          attributeName: this.form.attributeName,
          sort: this.form.sort || 0,
          remark: this.form.remark,
          valueList
        }
        request.post('/base/materialAttribute/' + (this.form.materialAttributeId ? 'update' : 'save'), body).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/materialAttribute/delete', { materialAttributeId: this.form.materialAttributeId }).then(() => {
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
@media (max-width: 760px) {
  .attribute-form-col { width: 100%; }
}
</style>
